import React from 'react';
import { Tag } from 'antd';

const AddOnTag = ({ name, color, enabled, style = {} }) => {
	if (!enabled) return null;

	return (
		<Tag color={color} key={`${name}`} style={style}>
			{name}
		</Tag>
	);
};

export default AddOnTag;



// WEBPACK FOOTER //
// ./src/components/AddOnTag.jsx